import { Tab as TabPrimitive } from '@headlessui/react';
import classNames from 'classnames';

type TableTabProps = {
  children: React.ReactNode;
  isLeft?: boolean;
};

export const TableTab = ({ children, isLeft }: TableTabProps) => (
  <TabPrimitive
    className={({ selected }) =>
      classNames(
        'focus:outline-none px-4 py-1 h-full',
        isLeft ? 'rounded-l-lg border-r border-ds-natural-150' : 'rounded-r-lg',
        {
          'bg-ds-natural-100': selected,
        }
      )
    }
  >
    {({ selected }) => (
      <div
        className={classNames(
          'flex rounded-md',
          selected
            ? 'text-ds-primary-300 hover:text-ds-primary-300'
            : 'text-ds-natural-600 hover:text-ds-natural-500'
        )}
      >
        {children}
      </div>
    )}
  </TabPrimitive>
);
